// SDK de JavaScript de Facebook, cargado solo cuando hace falta (al conectar WhatsApp). Se carga una vez por página.
const GRAPH_VERSION = process.env.REACT_APP_META_GRAPH_VERSION || 'v23.0';
let loading = null;

export function loadFacebookSdk(appId) {
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const ready = () => { window.FB.init({ appId, autoLogAppEvents: true, xfbml: false, version: GRAPH_VERSION }); resolve(window.FB); };
    if (window.FB) { ready(); return; }
    window.fbAsyncInit = ready;
    const s = document.createElement('script');
    s.src = 'https://connect.facebook.net/es_LA/sdk.js';
    s.async = true; s.defer = true; s.crossOrigin = 'anonymous';
    s.onerror = () => { loading = null; s.remove(); reject(new Error('No se pudo cargar el SDK de Facebook. Revisa tu conexión o si un bloqueador de anuncios lo impide, e intenta de nuevo.')); };
    document.head.appendChild(s);
  });
  return loading;
}
